import { RESET_STATE, GET_ORDER_ITEMS, UPDATE_ORDER_DETAILS, SET_UPLOAD_ORDERS_FILE_ACTION, SET_UPLOAD_ORDERS_FILE_BATCH, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	order_items: {},
	order_details: {
		userDetails: {},
	},
	showUploadOrdersFile: false,
	uploadOrdersFileAction: '',
	uploadOrdersFileBatch: '',
	uploadOrdersFileType: '',
};

export default function (state = initialState, action) {
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case GET_ORDER_ITEMS:
			return {
				...state,
				order_items: action.payload,
			};

		case UPDATE_ORDER_DETAILS:
			return {
				...state,
				order_details: action.payload,
			};

		case SET_UPLOAD_ORDERS_FILE_ACTION:
			const showUploadOrdersFile = action.payload.showUploadOrdersFile || false;
			const uploadOrdersFileType = action.payload.uploadOrdersFileType || '';
			const uploadOrdersFileAction = action.payload.uploadOrdersFileAction || '';
			return {
				...state,
				showUploadOrdersFile,
				uploadOrdersFileType,
				uploadOrdersFileAction,
			};

		case SET_UPLOAD_ORDERS_FILE_BATCH:
			const uploadOrdersFileBatch = action.payload.uploadOrdersFileBatch || '';
			return {
				...state,
				uploadOrdersFileBatch,
			};

		case ACTION_LOGOUT_INITIATED:
			return initialState;	
			
		default:
			return state;
	}
}
